<template>
  <modal ref="customerModal">
    <span slot="activator">
      <slot name="activator"></slot>
    </span>
    <div slot="header">{{ $t('Onboard customer') }}</div>
    <div class="ui top attached tabular menu">
      <a
        :class="{ active: currentTab == 0 }"
        class="item teal"
        @click="changeAction('search', 0)"
        >{{ $t('Search for a customer') }}</a
      >
      <a
        :class="{ active: currentTab == 1 }"
        class="item violet"
        @click="changeAction('create', 1)"
        >{{ $t('Create a new customer') }}</a
      >
    </div>
    <div>
      <!-- Choose ??? -->
      <div v-if="customer_action === 'choose'" class="choose">
        <div class="ui container center aligned">
          <button class="ui button purple" @click="customer_action = 'create'">
            <i class="add user icon"></i>{{ $t('Create a new customer') }}
          </button>
          <button class="ui button blue" @click="customer_action = 'search'">
            <i class="search icon"></i>{{ $t('Search for a customer') }}
          </button>
        </div>
      </div>

      <!-- Create -->
      <div v-if="currentTab == 1" class="create">
        <table class="ui celled table">
          <tbody>
            <tr>
              <td>{{ $t('Gender') }}</td>
              <td>
                <select
                  v-model="customer.id_gender"
                  class="ui fluid dropdown selection"
                >
                  <option value="1" selected>{{ $t('Mr') }}</option>
                  <option value="2">{{ $t('Mrs') }}</option>
                  <option value="3">{{ $t('Unknow') }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>{{ $t('Lastname') }}</td>
              <td>
                <span v-if="errors.first('lastname')" class="error">{{
                  errors.first('lastname')
                }}</span>
                <div
                  :class="{ error: errors.first('lastname') }"
                  class="ui fluid input"
                >
                  <input
                    v-validate="'required'"
                    ref="focusCreate"
                    v-model="customer.lastname"
                    type="text"
                    placeholder
                    name="lastname"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ $t('Firstname') }}</td>
              <td>
                <span v-if="errors.first('firstname')" class="error">{{
                  errors.first('firstname')
                }}</span>
                <div
                  :class="{ error: errors.first('firstname') }"
                  class="ui fluid input"
                >
                  <input
                    v-validate="'required'"
                    v-model="customer.firstname"
                    type="text"
                    placeholder
                    name="firstname"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td class="four wide">{{ $t('Email') }}</td>
              <td>
                <span v-if="errors.first('email')" class="error">{{
                  errors.first('email')
                }}</span>
                <div
                  :class="{ error: errors.first('email') }"
                  class="ui fluid input"
                >
                  <input
                    v-validate="'required|email'"
                    v-model="customer.email"
                    type="email"
                    placeholder
                    name="email"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td class="four wide">
                {{ $t('Email parrain') }}
              </td>
              <td>
                <span v-if="errors.first('invitation')" class="error">{{
                  errors.first('invitation')
                }}</span>
                <div
                  :class="{ error: errors.first('invitation') }"
                  class="ui fluid input"
                >
                  <input
                    v-validate="'email'"
                    v-model="customer.referralprogram"
                    type="email"
                    placeholder
                    name="invitation"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="center aligned">
                <button
                  :class="{ loading: loading }"
                  :disabled="loading"
                  class="ui button green"
                  @click="create()"
                >
                  {{ $t('Create') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Search -->
      <div v-else-if="currentTab == 0" class="search">
        <!-- Search input -->
        <table class="ui celled table">
          <tbody>
            <tr>
              <td>{{ $t('Lastname') }}</td>
              <td>
                <div class="ui fluid action input lastnameInput">
                  <input
                    ref="focusSearch"
                    v-model="search.lastname"
                    type="text"
                    placeholder
                    autofocus
                    @keyup.enter="fetchSearch('lastname')"
                  />
                  <button class="ui button" @click="fetchSearch('lastname')">
                    {{ $t('Search') }}
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ $t('Firstname') }}</td>
              <td>
                <div class="ui fluid action input firstNameInput">
                  <input
                    ref="focusSearch"
                    v-model="search.firstname"
                    type="text"
                    placeholder
                    autofocus
                    @keyup.enter="fetchSearch('firstname')"
                  />
                  <button class="ui button" @click="fetchSearch('firstname')">
                    {{ $t('Search') }}
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td class="four wide">{{ $t('Email') }}</td>
              <td>
                <div class="ui fluid action input">
                  <input
                    v-model="search.email"
                    type="email"
                    placeholder
                    @keyup.enter="fetchSearch('email')"
                  />
                  <button class="ui button" @click="fetchSearch('email')">
                    {{ $t('Search') }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Search result -->
        <table class="ui celled table">
          <thead>
            <tr>
              <th>{{ $t('Name') }}</th>
              <th>{{ $t('Email') }}</th>
              <th class="two wide"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="customer_search">
              <td colspan="3">
                <div class="ui inverted segment">
                  <p></p>
                  <div class="ui active">
                    <div class="ui inverted loader"></div>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-else-if="customers.length == 0" class="no-customers">
              <td colspan="3">{{ $t('No customers') }}</td>
            </tr>
            <tr v-for="(customer, index) in customers" :key="index">
              <td>{{ customer.lastname + ' ' + customer.firstname }}</td>
              <td>{{ customer.email }}</td>
              <td>
                <button class="ui compact button" @click="choose(customer)">
                  {{ $t('Choose') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<style scoped>
.error {
  color: #c00;
}

.attached .item {
  font-size: 14px;
  padding-top: 10px;
}
</style>

<script>
import axios from 'axios'

export default {
  name: 'Customer',
  data() {
    return {
      loading: false,
      customer: {
        email: '',
        id_gender: 1,
        firstname: '',
        lastname: '',
        referralprogram: ''
      },
      search: {
        firstname: '',
        lastname: '',
        email: ''
      },
      customers: [],
      customer_search: false,
      customer_action: 'search',
      currentTab: 0
    }
  },
  methods: {
    reset() {
      this.customer = {
        email: '',
        firstname: '',
        lastname: '',
        gender: 1
      }
      this.search = {
        lastname: '',
        email: ''
      }
      this.customers = []
      this.customer_search = false
      this.customer_action = 'search'
    },
    fetchSearch(field) {
      this.customer_search = true

      const obj = {}
      obj[field] = this.search[field]

      axios
        .post('/customers', obj)
        .then((response) => {
          this.customers = response.data.customers
        })
        .finally(() => {
          this.customer_search = false
        })
    },
    choose(customer) {
      axios.get(`/customer/${customer.id}/orders`).then((response) => {
        // eslint-disable-next-line no-param-reassign
        customer.orders = response.data.orders
        this.$store.dispatch('addCustomer', customer)
        // this.$store.dispatch('setCurrentCustomerOrders', response.data.orders);

        this.$refs.customerModal.close()
        this.reset()
        this.$router.push({ name: 'CustomerView' })
      })
    },
    changeAction(action, tab) {
      this.customer_action = action
      this.currentTab = tab

      if (action === 'search') {
        this.$nextTick(() => this.$refs.focusSearch.focus())
      } else this.$nextTick(() => this.$refs.focusCreate.focus())
    },
    create() {
      const self = this
      this.$validator.validate().then((result) => {
        if (!result) {
          return
        }
        this.loading = true
        self.customer.email_create = 1
        self.customer.is_new_customer = 1
        axios
          .post('/customers/create', self.customer)
          .then((response) => {
            const { customer } = response.data
            this.loading = false

            const obj = {
              email: customer.email
            }
            axios.post('/customers', obj).then((response2) => {
              if (response2.data.customers.length === 1) {
                this.choose(response2.data.customers[0])
              }
            })
          })
          .catch((err) => {
            // eslint-disable-next-line
            console.log(err)
            this.loading = false
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CustomerModal.vue?49303699